export default "__VITE_ASSET__BRndkWpk__"